import {Maps} from './Maps'


(function () {
    // Function to call main menu from hotels
    function callMainMenu(e) {
        e.preventDefault()
        const $mainNav = document.querySelector('#side-nav')
        if ($mainNav) {
            $mainNav.getNav().setDelayOverride(true)
            $mainNav.getNav().open()
            $mainNav.getNav().setDelayOverride(false)
        }
    }
    
    // Hotels Group
    if (document.querySelector('#hotels')) {
        const $subNavLinks = document.querySelectorAll('[href*="#hotels?"]')
        const $mobileBackLink = document.querySelector('#hotels .mobile-back-link')
        
        $subNavLinks.forEach(function ($link) {
            $link.addEventListener('click', function (e) {
                e.preventDefault()
                const filterVal = this.getAttribute('href').split('?')[1]
                const $HotelSheet = document.querySelector('#hotel-list-sheet')
                const $hotelsMainListItems = document.querySelectorAll('.hotels__main-list-item')
                $HotelSheet.getNav().setDelayOverride(true)
                $HotelSheet.getNav().open()
                $HotelSheet.getNav().setDelayOverride(false)
                
                $hotelsMainListItems.forEach(($item) => {
                    const $itemId = $item.getAttribute('id')

                    console.log($itemId === `main-${filterVal}`)
                    if($itemId === `${filterVal}`) {
                        $item.style.display = 'block'
                        $item.style.overflow = 'auto'
                        return
                    }
                    $item.style.overflow = 'hidden'
                    $item.style.display = 'none'
                }) // Reset items
                
            })
        })

        $mobileBackLink?.addEventListener('click', callMainMenu)
    }
   
    if(document.querySelector('#hotspots')){
        new Maps.HotSpots(document.querySelector('#hotspots'))
    }

})()

